import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';

var descriptionListThemeWeb = {
  label: {
    fontSize: 18,
    color: colors.octoberGrey
  },
  description: {
    fontWeight: 500,
    fontSize: 18,
    color: 'text'
  },
  dividerColor: colors.cloudGrey
};
var descriptionListDarkThemeWeb = _extends({}, descriptionListThemeWeb, {
  label: _extends({}, descriptionListThemeWeb.label, {
    color: colors.fogGrey
  }),
  description: _extends({}, descriptionListThemeWeb.description, {
    colors: 'text'
  }),
  dividerColor: colors.inkGrey
});

export { descriptionListDarkThemeWeb, descriptionListThemeWeb };
